import { Button, InputAdornment, InputBaseComponentProps, ListItem, ListItemText, MenuItem, TextField } from "@mui/material";
import React from "react";

export interface SelectOptionInterface {
    value: string | number,
    label: string
}

export interface TextSelectFormListItemProps {
    text: string,
    initialValue: string,
    initialValueSelect: string | number,
    startAdornmentText?: string,
    endAdornmentText?: string,
    onSave?: (value: string, valueSelect: string | number) => void
    onValidate?: (value: string, valueSelect: string | number) => void,
    inputProps?: InputBaseComponentProps,
    error?: boolean,
    helperText?: string,
    selectOptions?: SelectOptionInterface[]
}

const TextSelectFormListItem: React.FC<TextSelectFormListItemProps> = ({
    text,
    initialValue,
    initialValueSelect,
    startAdornmentText,
    endAdornmentText,
    onSave,
    onValidate,
    inputProps,
    error,
    helperText,
    selectOptions,
}) => {
    const [value, setValue] = React.useState(initialValue)
    const [valueSelect, setValueSelect] = React.useState(initialValueSelect)

    React.useEffect(() => {
        setValue(initialValue)
        setValueSelect(initialValueSelect)
    }, [initialValue, initialValueSelect])

    return (
        <ListItem>
            <ListItemText primary={text} />
            <TextField
                variant="standard"
                inputProps={inputProps}
                InputProps={{
                    startAdornment: <InputAdornment position="start">{startAdornmentText}</InputAdornment>,
                    endAdornment: <InputAdornment position="end">{endAdornmentText}</InputAdornment>
                }}
                onChange={e => {
                    if (onValidate) {
                        onValidate(e.target.value, valueSelect)
                    }
                    setValue(e.target.value)
                }}
                error={error ? error : false}
                helperText={helperText}
                value={value}
            />
            <TextField
                select
                variant="standard"
                value={valueSelect}
                onChange={e => {
                    if (onValidate) {
                        onValidate(value, e.target.value)
                    }
                    setValueSelect(e.target.value)
                }}
                sx={{ marginLeft: "10px" }}
            >
                {selectOptions?.map((opt, index) => (
                    <MenuItem value={opt.value} key={index}>{opt.label}</MenuItem>
                ))}
            </TextField>
            <Button
                variant="outlined"
                sx={{ marginLeft: "1em" }}
                onClick={() => {
                    if (onSave) {
                        onSave(value, valueSelect)
                    }
                }}
                disabled={error}
            >保存</Button>
        </ListItem>
    );
}

export default TextSelectFormListItem